import React, { useState, useEffect } from 'react';
import { getUserDetail, updateProfile, changePassword, changeEmail } from '../../api';
import theme from '../../theme';

const UserProfile = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [activeTab, setActiveTab] = useState('profile');

  // 个人信息表单状态
  const [profileForm, setProfileForm] = useState({
    first_name: '',
    last_name: '',
    email: ''
  });

  // 修改密码表单状态
  const [passwordForm, setPasswordForm] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });

  // 修改邮箱表单状态
  const [emailForm, setEmailForm] = useState({
    new_email: '',
    password: ''
  });

  // 获取用户详细信息
  useEffect(() => {
    fetchUserDetail();
  }, []);

  const fetchUserDetail = async () => {
    try {
      const response = await getUserDetail();
      const data = response.data;
      setUserInfo(data);
      
      // 初始化表单数据
      setProfileForm({
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        email: data.email || ''
      });
    } catch (error) {
      showMessage('获取用户信息失败', 'error');
    }
  };

  const showMessage = (msg, type = 'info') => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 3000);
  };

  // 更新个人信息
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await updateProfile(profileForm);
      showMessage('个人信息更新成功！', 'success');
      
      // 更新用户信息显示
      setUserInfo(response.data.user);
      
    } catch (error) {
      showMessage(error.response?.data?.detail || '个人信息更新失败', 'error');
    } finally {
      setLoading(false);
    }
  };

  // 修改密码
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (passwordForm.new_password !== passwordForm.confirm_password) {
        showMessage('新密码和确认密码不匹配', 'error');
        return;
      }

      await changePassword(passwordForm);
      showMessage('密码修改成功！请重新登录', 'success');
      
      // 清空表单
      setPasswordForm({
        old_password: '',
        new_password: '',
        confirm_password: ''
      });

      // 延迟跳转到登录页
      setTimeout(() => {
        localStorage.removeItem('token');
        window.location.href = '/';
      }, 2000);

    } catch (error) {
      showMessage(error.response?.data?.detail || '密码修改失败', 'error');
    } finally {
      setLoading(false);
    }
  };

  // 修改邮箱
  const handleChangeEmail = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await changeEmail(emailForm);
      showMessage('邮箱修改成功！', 'success');
      
      // 清空表单
      setEmailForm({
        new_email: '',
        password: ''
      });

      // 重新获取用户信息
      fetchUserDetail();

    } catch (error) {
      showMessage(error.response?.data?.detail || '邮箱修改失败', 'error');
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 8px #e5e5e5',
    padding: 32,
    marginBottom: 24,
  };

  const tabStyle = (isActive) => ({
    padding: '12px 24px',
    border: 'none',
    background: isActive ? '#5a7d1a' : '#f5f5f5',
    color: isActive ? '#fff' : '#333',
    borderRadius: '8px 8px 0 0',
    cursor: 'pointer',
    fontWeight: isActive ? 600 : 400,
    marginRight: 8,
  });

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    marginBottom: 16,
  };

  const buttonStyle = {
    background: theme.BUTTON_BG,
    color: '#fff',
    border: 'none',
    padding: '12px 24px',
    borderRadius: 8,
    fontSize: 14,
    cursor: 'pointer',
    fontWeight: 500,
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    background: '#ccc',
    cursor: 'not-allowed',
  };

  const renderProfileTab = () => (
    <div>
      {/* 用户信息卡片 */}
      <div style={cardStyle}>
        <h3 style={{ marginBottom: 24, color: '#333' }}>个人信息</h3>
        {userInfo && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>用户名</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>{userInfo.username}</div>
            </div>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>邮箱</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>{userInfo.email || '未设置'}</div>
            </div>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>角色</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>{userInfo.role_display || userInfo.role}</div>
            </div>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>用户组</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>{userInfo.group?.name || '未分配'}</div>
            </div>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>注册时间</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>
                {new Date(userInfo.date_joined).toLocaleDateString()}
              </div>
            </div>
            <div>
              <label style={{ color: '#666', fontSize: 14 }}>最后登录</label>
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>
                {userInfo.last_login ? new Date(userInfo.last_login).toLocaleString() : '从未登录'}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 修改个人信息卡片 */}
      <div style={cardStyle}>
        <h3 style={{ marginBottom: 24, color: '#333' }}>修改个人信息</h3>
        <form onSubmit={handleUpdateProfile}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>姓名</label>
              <input
                type="text"
                style={inputStyle}
                value={profileForm.first_name}
                onChange={(e) => setProfileForm({...profileForm, first_name: e.target.value})}
                placeholder="请输入姓名"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>姓氏</label>
              <input
                type="text"
                style={inputStyle}
                value={profileForm.last_name}
                onChange={(e) => setProfileForm({...profileForm, last_name: e.target.value})}
                placeholder="请输入姓氏"
              />
            </div>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>邮箱地址</label>
            <input
              type="email"
              style={inputStyle}
              value={profileForm.email}
              onChange={(e) => setProfileForm({...profileForm, email: e.target.value})}
              placeholder="请输入邮箱地址"
            />
          </div>
          <button
            type="submit"
            style={loading ? disabledButtonStyle : buttonStyle}
            disabled={loading}
          >
            {loading ? '更新中...' : '更新个人信息'}
          </button>
        </form>
      </div>
    </div>
  );

  const renderSecurityTab = () => (
    <div>
      {/* 修改密码卡片 */}
      <div style={cardStyle}>
        <h3 style={{ marginBottom: 24, color: '#333' }}>修改密码</h3>
        <form onSubmit={handleChangePassword}>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>当前密码</label>
            <input
              type="password"
              style={inputStyle}
              value={passwordForm.old_password}
              onChange={(e) => setPasswordForm({...passwordForm, old_password: e.target.value})}
              placeholder="请输入当前密码"
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>新密码</label>
            <input
              type="password"
              style={inputStyle}
              value={passwordForm.new_password}
              onChange={(e) => setPasswordForm({...passwordForm, new_password: e.target.value})}
              placeholder="请输入新密码"
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>确认新密码</label>
            <input
              type="password"
              style={inputStyle}
              value={passwordForm.confirm_password}
              onChange={(e) => setPasswordForm({...passwordForm, confirm_password: e.target.value})}
              placeholder="请再次输入新密码"
              required
            />
          </div>
          <button
            type="submit"
            style={loading ? disabledButtonStyle : buttonStyle}
            disabled={loading}
          >
            {loading ? '修改中...' : '修改密码'}
          </button>
        </form>
      </div>

      {/* 修改邮箱卡片 */}
      <div style={cardStyle}>
        <h3 style={{ marginBottom: 24, color: '#333' }}>修改邮箱</h3>
        <form onSubmit={handleChangeEmail}>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>新邮箱地址</label>
            <input
              type="email"
              style={inputStyle}
              value={emailForm.new_email}
              onChange={(e) => setEmailForm({...emailForm, new_email: e.target.value})}
              placeholder="请输入新的邮箱地址"
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>当前密码</label>
            <input
              type="password"
              style={inputStyle}
              value={emailForm.password}
              onChange={(e) => setEmailForm({...emailForm, password: e.target.value})}
              placeholder="请输入当前密码以验证身份"
              required
            />
          </div>
          <button
            type="submit"
            style={loading ? disabledButtonStyle : buttonStyle}
            disabled={loading}
          >
            {loading ? '修改中...' : '修改邮箱'}
          </button>
        </form>
      </div>

      {/* 安全提示 */}
      <div style={{
        ...cardStyle,
        background: '#fff3e0',
        border: '1px solid #ffcc02',
      }}>
        <h4 style={{ marginBottom: 16, color: '#e65100' }}>🔒 安全提示</h4>
        <ul style={{ color: '#e65100', lineHeight: 1.6, margin: 0, paddingLeft: 20 }}>
          <li>密码修改后需要重新登录</li>
          <li>请使用强密码，包含字母、数字和特殊字符</li>
          <li>邮箱修改后请及时验证新邮箱的有效性</li>
          <li>如遇问题请联系系统管理员</li>
        </ul>
      </div>
    </div>
  );

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 32, color: '#333' }}>个人账号管理</h2>

      {/* 消息提示 */}
      {message && (
        <div style={{
          padding: '12px 16px',
          borderRadius: 8,
          marginBottom: 24,
          background: messageType === 'success' ? '#e8f5e9' : '#ffebee',
          color: messageType === 'success' ? '#2e7d32' : '#c62828',
          border: `1px solid ${messageType === 'success' ? '#c8e6c9' : '#ffcdd2'}`,
        }}>
          {message}
        </div>
      )}

      {/* 标签页导航 */}
      <div style={{ marginBottom: 24 }}>
        <button
          style={tabStyle(activeTab === 'profile')}
          onClick={() => setActiveTab('profile')}
        >
          个人信息
        </button>
        <button
          style={tabStyle(activeTab === 'security')}
          onClick={() => setActiveTab('security')}
        >
          安全设置
        </button>
      </div>

      {/* 标签页内容 */}
      {activeTab === 'profile' && renderProfileTab()}
      {activeTab === 'security' && renderSecurityTab()}
    </div>
  );
};

export default UserProfile; 